import React from 'react';
import "./continueGenerate.css"
import { Button, Modal } from 'antd';


interface ContinueGenerateModelProps {
    visible: boolean;
    onOk: () => void;
    onCancel: () => void;
}
const ContinueGenerateModel = ({ visible, onOk, onCancel }: ContinueGenerateModelProps) => {

    return (
        <Modal
            closable={false}
            centered
            open={visible}
            onOk={onOk}
            footer={false}
            onCancel={onCancel}
            maskClosable={false}
            className="create-Query-modal"
            styles={{
                mask: { backdropFilter: "blur(14px)" },

            }}
        >
            <div className='isposibleModal'>
                <div className='row'>
                    <div className='col-lg-12'>
                        <div style={{ color: "#3D3D3D" }} >
                            <span style={{ fontWeight: 600, fontSize: '16px' }}>Note: </span>Report is based on token limits applicable to your current plan.
                        </div>
                    </div>

                </div>
                <div className='d-flex justify-content-end mt-3'>
                    <Button onClick={onCancel} className="queryModal-cancel-btn me-2">
                        Cancel
                    </Button>
                    <Button htmlType="submit" onClick={onOk} className="queryModal-save-btn">
                        Okay
                    </Button>
                </div>
            </div>
        </Modal>

    )
}

export default ContinueGenerateModel